import { Link } from 'react-router-dom';
import { ActivityPage, getActivityBrowseUrl } from '../utils/activitySectionLinks';
import styles from './ActivityBrowseLink.module.css';

export default function ActivityBrowseLink({ page, section, title }: { page: ActivityPage; section: string; title: string }) {
    return <div className={styles.container}>
        <Link to={getActivityBrowseUrl(page, section)} className={styles.link} aria-label={`Voir tous les événements : ${title}`}>
            Voir tous <span aria-hidden="true">→</span>
        </Link>
    </div>;
}
